import isDawn from '../../lib/isDawn'
import isLuna from '../../lib/isLuna'
import { ChargerProducts } from '../enums/Products'
import { EarthingSchemeLB } from '../enums/earthingSchemes'
import { EarthingSystem } from '../redux/api/web-api'

type ProductIdentity = { productId?: number } | number | string | null | undefined
type Aura2ProductIdentity = { productId?: number | null } | number
type EarthingSystemProductIdentity = {
    productId?: number | null
    earthingSystem?: EarthingSystem | null
}

export const isAura2 = (entity: Aura2ProductIdentity): boolean => {
    const productId = typeof entity === 'number' ? entity : entity?.productId

    return productId === ChargerProducts.Aura2
}

export const getSupportedEarthingSystem = (
    chargePoint: EarthingSystemProductIdentity
): EarthingSystem | null | undefined => (isAura2(chargePoint) ? EarthingSchemeLB.TN : chargePoint.earthingSystem)

export const supportsSimImsi = (entity: ProductIdentity): boolean => {
    if (entity == null) return false

    return isDawn(entity) || isLuna(entity) || (typeof entity !== 'string' && isAura2(entity))
}
